/* eslint-disable @typescript-eslint/camelcase */
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

const SendFeedbackEmail = ({ show, onClose, data, profile }) => {
  console.log(data, data.Customer_Number);

  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmitForm = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Prepare payload
      const payload = {
        customerNumbers: data.map((item) => item.cin),
        status: status,
      };

      const response = await fetch('https://api.tizeti.com/api/v1/feedback/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Failed to send data');

      toast.success('✅ Status updated successfully!');
    } catch (error) {
      console.error(error);
      toast.error('❌ Something went wrong, please try again');
    } finally {
      setLoading(false);
    }
  };

  const submitForm = () => {
    return status.length > 0;
  };

  const displayButton = () => {
    if (loading) {
      return (
        <button type="submit" className="btn btn-green" disabled={loading}>
          Sending Email...
        </button>
      );
    }
    return (
      <button type="submit" className="btn btn-green" disabled={!submitForm()}>
        Send Email
      </button>
    );
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ paddingLeft: '2rem' }}>Send Feedback Email</Modal.Title>
      </Modal.Header>

      <form className="form-horizontal" onSubmit={onSubmitForm}>
        <div className="form-group">
          <div className="col-12 mb-3">
            <div className="col-12">
              <select
                id="status"
                name="status"
                onChange={(e) => setStatus(e.target.value)}
                className="form-control border border-info py-2"
              >
                <option value="">--Select Status--</option>

                <option value="active">ACTIVE CUSTOMERS</option>
                <option value="inactive">EXPIRED CUSTOMERS</option>
              </select>
            </div>
          </div>

          {/* {status.length > 0 && (
            <div className="col-12 mb-3">
              <div className="col-12">
                <textarea className="form-control border border-info py-2" value={Helpers.messageToBeSent(status)} />
              </div>
            </div>
          )} */}
          <div className="col-12 mb-3 text-center">{displayButton()}</div>
        </div>
      </form>
    </Modal>
  );
};

export default SendFeedbackEmail;
